import Vue from "vue";
import Vuex from "vuex";
import store from "_private/config/store";

Vue.use(Vuex);

export default new Vuex.Store(store);
